/* eslint-disable no-undef */
import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import { Action } from "./Dropdown";
import { Box, ButtonPrimary, isEsopViewer } from "../utils";
import { BuybackType } from "../../pages/optionBuyback";
import Tooltip from "./Tooltip";
import { useAuthorizationStore } from "../../store";

function DropdownButton({
  actions,
  onAction,
  className = "items-end",
  render = () => (
    <Box className="flex items-center gap-1">
      <div>+</div>
      <div>Quick Actions</div>
    </Box>
  ),
}: {
  className?: string;
  actions: Action[] | BuybackType[];
  onAction: (action: any) => void;
  render?: () => JSX.Element;
}) {
  const isUserEsopViewer = isEsopViewer();
  const [dropdownOpen, setDropDownOpen] = React.useState(false);
  const contextRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const checkIfClickOutside = (e: any) => {
      if (!(dropdownOpen && contextRef.current?.contains(e.target))) {
        setDropDownOpen(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickOutside);
    };
  }, [dropdownOpen]);
  const RenderElement = render;
  return (
    <div className={`flex flex-col ${className} `} ref={contextRef}>
      <button
        disabled={isUserEsopViewer}
        onClick={() => {
          setDropDownOpen((state) => !state);
        }}
        className={`px-5 py-2 font-normal text-white rounded cursor-pointer peer h-11 text-sm1 bg-orange-p focus:opacity-90 hover:bg-orange-500 ${
          isUserEsopViewer ? "cursor-not-allowed" : ""
        }`}
        type="button"
      >
        <RenderElement />
      </button>
      {dropdownOpen && (
        <div
          id="dropdown"
          className="absolute z-10 bg-white border divide-y divide-gray-100 rounded shadow mt-11"
        >
          <p className="px-4 py-1 text-stone-300">Quick actions</p>
          <ul
            className="w-48 py-1 text-xs font-normal divide-y text-dark"
            aria-labelledby="dropdownDefault"
          >
            {actions.map((action, index) => (
              <Tooltip
                text={`${
                  action.disabled
                    ? "To create a new Event, Please complete your previous closed events"
                    : ""
                }`}
                key={index}
              >
                <li>
                  <a
                    href=""
                    className={` block px-4 py-2 hover:bg-gray-100  ${
                      action.disabled && "text-gray-300 cursor-not-allowed "
                    } `}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={(e) => {
                      e.preventDefault();
                      onAction(action);
                      setDropDownOpen((state) => !state);
                    }}
                  >
                    {action.name}
                  </a>
                </li>
              </Tooltip>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default DropdownButton;
